// @core/api/endpoints/document/create_clause.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateClauseRequest,
  DocumentClauseResponse,
} from '../../../types/document';

const BASE_PATH = '/document';

/**
 * Create clause
 * Creates a new reusable contract clause. Starts in DRAFT status until approved.
 */
export async function CreateClause(
  data: CreateClauseRequest,
  options?: RequestOptions
): Promise<DocumentClauseResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/clauses`;
  const requestOptions = options;
  return client.post<DocumentClauseResponse>(requestPath, data, requestOptions);
}
